import { render, staticRenderFns } from "./selectfile.vue?vue&type=template&id=79f6a638&scoped=true&"
import script from "./selectfile.vue?vue&type=script&lang=js&"
export * from "./selectfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f6a638",
  null
  
)

export default component.exports